<template>
  <div class="white">
    <div class="condition">
      <el-col :xs="24" :md="24" style="text-align: right;">
      </el-col>
    </div>
    <el-table :data="tableData" style="width: 100%" ref="inTable">
      <el-table-column prop="place_name" label="场地" min-width="150" align="center" fixed>
        <template slot-scope="scope">
          {{scope.row.place_name}}
        </template>
      </el-table-column>
      <el-table-column prop="is_only_allow_white" label="启用白名单" min-width="150" align="center">
        <template slot-scope="scope">
          {{showIsEnable(scope.row.is_only_allow_white)}}
        </template>
      </el-table-column>
    </el-table>

    <el-row style="text-align:center;margin-top:20px;" :gutter="20" v-if="tableData.length > 0">
      <el-col :span="24" >
        <el-button style="height:60px;width:100%;" :type="(set_is_only_allow_white==1)?'primary':'danger'" @click="setEnable()">{{showIsEnableBtn(set_is_only_allow_white)}}</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align:center;margin-top:20px;" :gutter="20">
      <el-col :span="24" >
        <el-button type="primary" @click="openSetGate()" style="height:60px;width:100%;">车道起匣</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align:center;margin-top:20px;" :gutter="20">
      <el-col :span="24">
        <el-button type="warning" @click="closeSetGate()" style="height:60px;width:100%;">车道落匣</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align:center;margin-top:20px;" :gutter="20">
      <el-col :span="24" >
        <el-button type="primary" @click="openWalkGate()" style="height:60px;width: 100%;">人行道门</el-button>
      </el-col>
    </el-row>

    <el-row style="text-align:center;margin-top:20px;" :gutter="20">
      <el-col :span="24" >
        <el-button type="primary" @click="keepWalkGate()" style="height:60px;width: 100%;">常开人行道门</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align:center;margin-top:20px;" :gutter="20">
      <el-col :span="24" >
        <el-button type="primary" @click="resetWalkGate()" style="height:60px;width: 100%;">常开人行道门恢复</el-button>
      </el-col>
    </el-row>
    <!-- <div class="open_walk" @click="openwalk()">人行门开门</div>
    <div class="open" @click="open()">匝道开门</div>
    <el-dialog title="匝道开门" :visible.sync="dialogOpen" :show-close="false" :center="true" width="360px">
      <el-form :model="openForm" status-icon ref="openForm" label-width="100px" class="demo-openForm">
        <el-form-item label="场地：">
          <loadSelect ref="loadSelect"
            :obj="{
              modelVal:placeId,
              disabled:false,
              optionVal:'place_id',
              optionName:'place_name',
              placeholder:'请选择'}"
            :url="'deviceManage/listPlace'" :formData="formFieldData" :parameter="false" @changeFn="changePlaceField">
          </loadSelect>
        </el-form-item>
        <el-form-item label="设备：">
          <loadSelect ref="loadSelect"
            :obj="{modelVal:placeDeviceId,disabled:false,optionVal:'place_device_id',optionName:'device_name',placeholder:'请选择' }"
            :url="'deviceManage/getDeviceListByPlaceId'" :formData="formDeviceData" :parameter="{ place_id: this.placeId}"
            @changeFn="changePlaceDeviceId"></loadSelect>
        </el-form-item>
        <el-form-item label="放行设备：">
          <loadSelect ref="loadSelect"
            :obj="{modelVal:deviceId,disabled:false,optionVal:'device_id',optionName:'device_name',placeholder:'请选择' }"
            :url="'deviceManage/getDeviceListByPlaceIdAndDevice'" :formData="formDeviceData" :parameter="{ place_id: this.placeId, place_device_id: this.placeDeviceId}"
            @changeFn="changeDeviceId"></loadSelect>
        </el-form-item>
        <div class="btn">
          <el-button round @click="dialogOpen = false">取消</el-button>
          <el-button type="primary" round @click="openSubmit( )">确定起匣</el-button>
          <el-button type="warning" round @click="closeSubmit( )">确定落匣</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="人行门开门" :visible.sync="dialogWalkOpen" :show-close="false" :center="true" width="360px">
      <el-form :model="openForm" status-icon ref="openForm" label-width="100px" class="demo-openForm">
        <el-form-item label="场地：">
          <loadSelect ref="loadSelect"
            :obj="{
              modelVal:placeId,
              disabled:false,
              optionVal:'place_id',
              optionName:'place_name',
              placeholder:'请选择'}"
            :url="'deviceManage/listPlace'" :formData="formFieldData" :parameter="false" @changeFn="changePlaceField">
          </loadSelect>
        </el-form-item>
        <div class="btn">
          <el-button round @click="dialogWalkOpen = false">取消</el-button>
          <el-button type="primary" round @click="openWalkSubmit( )">确定开门</el-button>
        </div>
      </el-form>
    </el-dialog>
  -->
  </div>

</template>

<script>
  import Util from '../../Util'
  import modal from '../../components/modal'
  import pagination from "../../components/pagination"
  import loadSelect from "../../components/loadSelect"
  export default {
    components: {
      modal,
      pagination,
      loadSelect,
    },
    data() {
      return {
        placeId: '',
        total: 0,
        form: {
          page: 1,
          size: 10,
        },
        formFieldData: { //场地分页
          page: 1,
          size: 50
        },
        pickerOptions: {
        },
        addForm: {},
        dialog: false,
        edit: false,
        tableData: [],
        placeDeviceId: '',
        deviceId: '',

        inPage: 1,
        inPageSize: 50,
        inTotal: 0,
        outPage: 1,
        outPageSize: 50,
        outTotal: 0,
        inPicture: true,
        outPicture: false,
        special: false,
        collect: false,
        dialogOpen: false,
        dialogWalkOpen: false,
        dialogCloseOpen: false,
        specialForm: {
          platDeviceId: "",
          direction: 1,
          reasonType: "",
          payFee: "",
          reasonContent: "",
          openOrder: 0,
          deviceId: ""
        },
        collectMoneyForm: {
          // platDeviceId: ""
          deviceId: ""
        },
        openForm: {
          place_id: '',
          place_device_id: '',
          device_id: '',
        },
        openWalkFrom: {
          place_id: '',
          place_device_id: '',
          device_id: '',
        },
        platId: '',
        carNum: "", //列表定时刷新时，存的车牌号
        queryCarNum: "", //搜索的车牌号
        reasonList: [{
          value: 0,
          label: '以其他价格放行'
        }, {
          value: 1,
          label: '不收费放行'
        }],
        directionList: [{
            value: 1,
            label: '进'
          },
          {
            value: 2,
            label: '出'
          }
        ],
        inData: [],
        outData: [],
        currentCar: {
          plat_id: ''
        }, //车辆信息对象
        checkCar: null, //点击记录赋值，实时上报时为true
        platDeviceList: [],
        websock: null, //实时上报对象
        actions: {}, //实时上报需要传的参数
        wsObj: null, //实时上报上来的数据对象
        formDeviceData: { //设备分页
          page: 1,
          size: 50
        },
        formFieldData: { //场地分页
          page: 1,
          size: 50
        },
        wsOpen: true, //记录ws心跳的变量
        // inCarSlot: {}
        modifyDialog: false,
        modifyForm: {
          carsNumber: '',
          usedCarsNumber: '',
          platId: ''
        },
        customForm: {
          inAuth: '',
          platId: ''
        },
        inImage: null,
        outImage: null,
        imgMode: 0,
        imgLocalUrl: 'http://192.168.3.242',
        imgGlobalUrl: 'https://img.parking.cxiot.cc',
        imgRate: 15,
        showStream: false,
        pickupInDevice:'',
        pickupOutDevice:'',
        inDoorDevices: [],
        outDoorDevices: [],
        set_is_only_allow_white:'',
        set_id:'',
        set_place_id:''
      }
    },
    computed: {

    },
    mounted() {
      this.getList();
    },
    methods: {
      changePlaceField(val) {
        this.placeId = val
        this.openForm.place_id = val;
        this.openForm.place_device_id = "";
        this.openForm.device_id = "";
        // this.pickupInDevice = '';
        // this.pickupOutDevice = '';
      },
      changePlaceDeviceId(val) {
        this.placeDeviceId = val;
        this.openForm.place_device_id = val;
        this.openForm.device_id = ""
      },
      changeDeviceId(val) {
        this.deviceId = val;
        this.openForm.device_id = val;
      },
      //   匝道开门-弹框
      open() {
        this.dialogOpen = true
        this.openForm.place_id = ""
        this.openForm.place_device_id = ""
        this.openForm.device_id = ""
        this.placeId = ""
        this.placeDeviceId = ""
        this.deviceId = ""
      },
      openwalk() {
        this.dialogWalkOpen = true
        this.openWalkFrom.place_id = ""
        this.openWalkFrom.place_device_id = ""
        this.openWalkFrom.device_id = ""
        this.placeId = ""
        this.placeDeviceId = ""
        this.deviceId = ""
      },
      //   匝道开门-接口
      openSubmit() {
        this.$refs["openForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/openGate`, this.openForm).then(
              res => {
                if (res.data.code === 200) {
                  this.dialogOpen = false
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        })
      },
      //   匝道关门-接口
      closeSubmit() {
        this.$refs["openForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/closeGate`, this.openForm).then(
              res => {
                if (res.data.code === 200) {
                  this.dialogOpen = false
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        })
      },
      //  行人道开门-接口
      openWalkSubmit() {
        this.$refs["openForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/openWalkSide`, this.openForm).then(
              res => {
                if (res.data.code === 200) {
                  this.dialogWalkOpen = false
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        })
      },
      setEnable() {
        let that = this;
        let params = {};
        params['id'] = that.set_id;
        params['is_only_allow_white'] = that.set_is_only_allow_white;
        params['place_id'] = that.set_place_id;
        console.log(params);
        let title = (that.set_is_only_allow_white == 1) ? "确定停用？" : "确定启用？";
        this.$confirm(title, '效期操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.searchURL}deviceManage/updatePlaceMode`, params)
                .then(
                  res => {
                    if (res.data.code === 200) {
                      let d = res.data.data
                      that.getList();
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      showIsEnable(val) {
        switch (val) {
          case 0:
            return "未启用";
            break;
          case 1:
            return "启用";
            break;
        }
      },
      showIsEnableBtn(val) {
        switch (val) {
          case 0:
            return "启用白名单：提早闭店";
            break;
          case 1:
            return "停用白名单";
            break;
        }
      },
      getList() {
        var that = this;
        this.$http.post(`${Util.searchURL}deviceManage/listPlace`, this.form)
        .then(
          res => {
            if (res.data.code === 200) {
              let d = res.data.data
              this.totalMessage = d.count_info || null
              this.tableData = d.data
              if (d.data[0].id==1) {
                that.set_is_only_allow_white =d.data[0].is_only_allow_white;
                that.set_id = d.data[0].id;
                that.set_place_id = d.data[0].place_id;
              }
              this.total = d.pageInfo.total
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      openSetGate() {
        let that = this;
        let params = {};
        params.place_id = "p1661960058";
        params.place_device_id = "d100001";
        params.device_id = "2056e63a-0438f840";
        this.$confirm("车道起匣", '设备操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.operateURL}deviceManage/openGate`, params ).then(
                  res => {
                    if (res.data.code === 200) {
                      this.dialogOpen = false
                      Util.message("suc", res.data.desc)
                    } else {
                      Util.message("err", res.data.desc)
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      closeSetGate() {
        let that = this;
        let params = {};
        params.place_id = "p1661960058";
        params.place_device_id = "d100001";
        params.device_id = "2056e63a-0438f840";
        this.$confirm("车道落匣", '设备操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.operateURL}deviceManage/closeGate`, params ).then(
                  res => {
                    if (res.data.code === 200) {
                      this.dialogOpen = false
                      Util.message("suc", res.data.desc)
                    } else {
                      Util.message("err", res.data.desc)
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      openWalkGate() {
        let that = this;
        let params = {};
        this.$confirm("开启人行道门", '设备操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.operateURL}deviceManage/openWalkSide`, params).then(
                  res => {
                    if (res.data.code === 200) {
                      Util.message("suc", res.data.desc)
                    } else {
                      Util.message("err", res.data.desc)
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      keepWalkGate() {
        let that = this;
        let params = {};
        this.$confirm("设定常开人行道门", '设备操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.operateURL}deviceManage/keepWalkSideOpen`, params).then(
                  res => {
                    if (res.data.code === 200) {
                      Util.message("suc", res.data.desc)
                    } else {
                      Util.message("err", res.data.desc)
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      resetWalkGate() {
        let that = this;
        let params = {};
        this.$confirm("常开人行道门复位", '设备操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.operateURL}deviceManage/resetWalkSide`, params).then(
                  res => {
                    if (res.data.code === 200) {
                      Util.message("suc", res.data.desc)
                    } else {
                      Util.message("err", res.data.desc)
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      handleSizeChange(val) {
        this.form.page = 1
        this.form.size = val
        this.getList()
      },
      //   改变页数时
      handleCurrentChange(val) {
        this.form.page = val
        this.getList()
      },
    }

  }

</script>

<style lang="less" scoped>
  .white {
    .el-card__header {

      .clearfix {
        color: #fff;
        text-align: center;
        font-size: 18px;
        margin: -18px -20px;
        background: #409EFF;
        height: 40px;
        line-height: 40px;
      }
    }

    .hei_200 {
      height: 214px;
    }

    .hei_220 {
      height: 235px;
    }

    .hei_450 {
      height: 573px;
      overflow-y: auto;

      h2 {
        text-align: center;
        padding: 20px 0px 40px 0px;
      }

      p {
        line-height: 30px;
        font-size: 20px;

        span {
          color: red;
          font-size: 28px
        }
      }
    }

    .no_picture {
      line-height: 200px;
      text-align: center;
    }

    .card_botm {
      margin-bottom: 20px;

      img {
        width: 100%;
        min-width: 150px;
        height: 240px;
      }
    }

    .btn {
      margin-top: 54px;
      text-align: center;

      button {
        width: 108px;
        padding: 6px 25px;
        margin-bottom: 5px;
      }
    }

    .el-table__body {
      width: 100%
    }

    .p0 {
      .el-card__body {
        padding: 0px !important;
      }

      .el-card__header {
        border-bottom: none
      }

      .el-table td,
      .el-table th {
        padding: 3px 0;
      }
    }

    .tr-ba-clor {
      background-color: #ecf5ff !important;
    }

    .open {
      position: fixed;
      border: 1px solid #79ace0;
      width: 30px;
      z-index: 1000;
      right: 20px;
      top: 50%;
      background: #79ace0;
      border-radius: 5px;
      text-align: center;
      padding: 5px 0px;
      color: #fff;
      cursor: pointer;
    }

    .open:hover {
      border: 1px solid #409eff;
      background: #409eff;
    }

    .open_walk {
      position: fixed;
      border: 1px solid #79ace0;
      width: 30px;
      z-index: 1000;
      right: 20px;
      top: 20%;
      background: #79ace0;
      border-radius: 5px;
      text-align: center;
      padding: 5px 0px;
      color: #fff;
      cursor: pointer;
    }

    // .in-car-msg {
    //   right: 0% !important;
    // }
  }

  .typer {
    width: 450px;
  }
  .typer ul{
    display:flex;
    flex-wrap: wrap;
  }
  .typer ul li{
    list-style: none;
    font-size:25px;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/page/simple/index.vue